import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import AllMember from './allMember';
import { useNavigate, useParams } from 'react-router-dom';
import ReferralDetails from './referralDetails';
import { useGetTotalActivateIncome, useUserLevelHistory, useUserMissedHistory, useUserSingleLevelDetails } from '../api/upgradeApi';
import { useDebounce } from '../../../hook/debounce';
import MissedDetails from './missedDetails';
import PendingDetails from './pendingDetails';
import { useProfileDetails } from '../../profile-details/api/profileapi';
import { useModalContext } from '../../../contexts/ModalContext';
import Loader from '../../Loader/buttonLoad';

const LevelDetails = () => {
    const [activeTab, setActiveTab] = useState('All');
    const { data: levelDetails } = useUserLevelHistory()

    const { data: userProfile } = useProfileDetails()


    const navigate = useNavigate()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab)
        setSearch('');
        setPage(0)
        setRowsPerPage(10)
    }
    const { id } = useParams()
    const levelIndex = parseInt(id) - 1; // Convert to number and adjust for 0-based index

    // Find the specific level from the data
    const levelData = levelDetails?.data?.find(item => parseInt(item._id) === levelIndex);
    const activeLevels = userProfile?.directMembers || 0;

    const completeActiveLevels = userProfile?.completedLevels || 0;

    const { search, setSearch } = useModalContext()

    const searchText = useDebounce(search)

    const { data: missedHistory, isLoading: missedLoading } = useUserMissedHistory({
        level: id - 1, searchText, page,
        size: rowsPerPage,
    })
    const { data: ActivateAmount, isLoading: activeLoading } = useGetTotalActivateIncome({
        level: id - 1
    })

    const { data: singalLevel, isLoading: levelLoading, refetch } = useUserSingleLevelDetails({
        level: id - 1, page,
        size: rowsPerPage,
        searchText,
        type: activeTab
    })



    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, refetch]);

    return (

        <>
            {(missedLoading || activeLoading || levelLoading) && <Loader />}

            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/upgrade-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Level Details</span>
                        </div>

                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 p-lg-4">
                                    <div className="row align-items-center">
                                        <div className="col-lg-auto col-md-auto">
                                            <div className="appDarkCard mb-3 mb-md-0">
                                                <div className="levelbx">
                                                    <div>
                                                        <div className='levelnumber'> {String(id).padStart(2, '0')} <span className='smTxt'>Level</span></div>
                                                    </div>
                                                    <div className='activeBx'>
                                                        <div className={`checkbx ${id <= activeLevels ? 'active' : ''}`}></div>
                                                        <div className='label'>Referral</div>
                                                    </div>
                                                    <div className='activeBx'>
                                                        <div className={`checkbx ${id - 1 <= completeActiveLevels && userProfile?.zorothlevelStatus ? 'active' : ''}`}></div>
                                                        <div className='label'>Top Up</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg col-md">
                                            <div className="d-flex g-15 flex-wrap justify-content-between rightLevelcnt">
                                                <div className='flex-fill'>
                                                    <div className='labelTxt'>Received Amount</div>
                                                    <div className='labelVal'>{levelData ? parseFloat(levelData?.reward || 0).toFixed(3) : '0.000'}   <span className='smTxt'>USDT</span></div>
                                                </div>
                                                <div className='flex-fill'>
                                                    <div className='labelTxt'>Activate Income</div>
                                                    <div className='labelVal'>{ActivateAmount?.result ? parseFloat(ActivateAmount?.result).toFixed(3) : 0} <span className='smTxt'>USDT</span></div>
                                                </div>
                                                <div className='flex-fill'>
                                                    <div className='labelTxt'>Missing Amount</div>
                                                    <div className='labelVal'>{levelData ? parseFloat(levelData?.missingRewardAmount || 0).toFixed(3) : '0.000'} <span className='smTxt'>USDT</span></div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                        <Nav pills className='mypillsTabs'>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'All' })}
                                                    onClick={() => { toggle('All'); }}
                                                >
                                                    All Members
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'upgrade' })}
                                                    onClick={() => { toggle('upgrade'); }}
                                                >
                                                    Received Amount
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'Pending' })}
                                                    onClick={() => { toggle('Pending'); }}
                                                >
                                                    Pending Referral
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'Missing' })}
                                                    onClick={() => { toggle('Missing'); }}
                                                >
                                                    Missing Amount
                                                </NavLink>
                                            </NavItem>

                                        </Nav>
                                    </div>
                                    <div className="tabcnt">
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="All">
                                                <AllMember />
                                            </TabPane>
                                            <TabPane tabId="Missing">
                                                <MissedDetails singalLevel={missedHistory} search={search}
                                                    setSearch={setSearch} page={page} setPage={setPage} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} />
                                            </TabPane>
                                            <TabPane tabId="upgrade">
                                                <ReferralDetails singalLevel={singalLevel} search={search}
                                                    setSearch={setSearch} page={page} setPage={setPage} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} />
                                            </TabPane>
                                            <TabPane tabId="Pending">
                                                <PendingDetails />
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default LevelDetails;